import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select'
import 'tom-select/dist/css/tom-select.min.css'
import '../stylesheets/tom-select.css'

export default class extends Controller {
  connect () {
    this.tomselect = new TomSelect(this.element, {
      allowEmptyOption: true,
      plugins: ['dropdown_input', 'clear_button'],
      render: {
        no_results: function (data, escape) {
          return '<div class="no-results">検索結果が見つかりませんでした: "' + escape(data.input) + '"</div>'
        }
      }
    })
  }

  disconnect () {
    this.tomselect.destroy()
  }
}
